<template>
  <div class="new-drawer-form">
    <slot name="tips"></slot>
    <div class="drawer-title">
      <span>{{ searchLabel }}</span>
    </div>
    <div style="position:relative">
      <div style="display:flex" class="mb10">
        <el-autocomplete
          v-model="keywords"
          :placeholder="placeholder"
          class="input-with-select"
          size="mini"
          :fetch-suggestions="querySearch"
          @focus="showHistory"
          @keypress.native="
            e => {
              e.keyCode === 13 && doSearch()
            }
          "
        >
        </el-autocomplete>
        <i class="el-icon-search drawer-search-icon" @click="doSearch"></i>
      </div>
      <div>
        <el-checkbox v-if="searchType === '人选'" v-model="searchFormer" class="searchFormer-checkbox"
          >搜索曾任职公司
          <el-tooltip
            class="item"
            effect="dark"
            content="勾选后通过姓名+公司可以搜索出曾经任职过该公司的人选"
            placement="top"
          >
            <i class="el-icon-warning-outline" style="display: inline;"></i> </el-tooltip
        ></el-checkbox>
      </div>
      <SearchHistory
        style="left: 2px;transform:translateY(-10px)"
        :is-history-show="isHistoryShow"
        :search-type="searchType"
        @setKeywords="setKeywords"
      ></SearchHistory>
    </div>
    <slot name="defaultItems"></slot>
  </div>
</template>
<script>
import SearchHistory from '../commonComponents/searchHistory'

export default {
  components: { SearchHistory },
  props: {
    showHistorySearchType: { type: String, default: '' },
    searchLabel: { type: String, default: '' },
    searchType: { type: String, default: '' },
    placeholder: { type: String, default: '请输入搜索' },
  },
  data: function() {
    return {
      searchFormer: false,
      keywords: '',
      isHistoryShow: false,
    }
  },
  watch: {
    showHistorySearchType(newValue, oldValue) {
      if (newValue !== this.searchType) this.isHistoryShow = false
    },
  },
  methods: {
    showHistory() {
      this.isHistoryShow = true
      this.$emit('showHistory', this.searchType)
    },
    setKeywords: function(kw) {
      this.keywords = kw
      this.doSearch()
    },
    async doSearch() {
      this.checkSelect()
      this.$emit('doSearch', { type: this.searchType, keywords: this.keywords, searchFormer: this.searchFormer })
      this.isHistoryShow = false
    },
    async querySearch(queryString, cb) {
      if (this.searchType !== '薪酬' || !queryString) return cb([])
      const res = await app.service('company').serchCompany(this.keywords)
      if (res.status === 200) {
        const restaurants = res.data.map(val => ({ value: val.简称 }))
        const results = queryString ? restaurants.filter(val => val.value.includes(queryString)) : restaurants
        cb(results)
      } else cb([])
    },
    checkSelect() {
      const { searchType, keywords, restaurants = [] } = this
      if (searchType !== '薪酬') return
      const company = restaurants.find(v => v.value === keywords)
      if (company) this.$emit('salaryChooseCompany', company.value)
    },
  },
}
</script>
<style scoped>
.input-with-select {
  width: 100%;
}
.new-drawer-form {
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 15px;
  padding-top: 15px;
  border: none;
  border-bottom: 6px solid #f1f3f4;
}
.drawer-title {
  padding-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #262626;
}
.drawer-search-icon {
  font-size: 16px;
  line-height: 28px;
  margin-left: 16px;
  cursor: pointer;
  z-index: 1001;
  position: relative;
}
</style>
<style>
.searchFormer-checkbox {
  margin-top: -20px;
  margin-left: 10px;
}
.searchFormer-checkbox .el-checkbox__label {
  font-size: 12px;
  color: #6666;
}
.searchFormer-checkbox .el-checkbox__inner {
  width: 12px;
  height: 12px;
}
</style>
